import ReactGA from "react-ga"
import { useSelector } from "react-redux"
import { useEffect } from "react"

import { IRedux } from "../services/types"

const GoogleAnalytics = () => {
  const settings = useSelector((state: IRedux) => state.settings?.extended)

  useEffect(() => {
    if (!settings || !settings.googleAnalyticsCode) return
    ReactGA.initialize(settings.googleAnalyticsCode)
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [settings])

  return null
}

export default GoogleAnalytics
